import React, {useEffect} from "react"

type Props = {}

const PricingSlider = (props: Props) => {
	useEffect(() => {
		const scriptSlider = document.createElement("script")
		scriptSlider.src = "/sliderBundle8.js"
		scriptSlider.async = true

		document.body.appendChild(scriptSlider)
		return () => {
			document.body.removeChild(scriptSlider)
		}
	}, [])
	return (
		<div className={"pricingSlider"}>
			<div id={"first-one-slider"} />
		</div>
	)
}

export default PricingSlider
